import * as jwt from "jsonwebtoken";
import * as api from "~/api";
import { KEY_NAME } from "~/configs";
import { PRESCRIBE } from "~/utils/urlApi";

export const getAllPrescribe = (baseUrl, data) => {
  data.sign = jwt.sign(data, KEY_NAME);
  return api.postHttpRequestAsync(`${baseUrl}${PRESCRIBE.GET_ALL}`, data);
};

export const getDetailByDatePrescribe = (baseUrl, data) => {
  data.sign = jwt.sign(data, KEY_NAME);
  return api.postHttpRequestAsync(
    `${baseUrl}${PRESCRIBE.GET_DETAIL_BY_DATE}`,
    data
  );
};

export const getPDFPrescribe = (baseUrl, data) => {
  data.sign = jwt.sign(data, KEY_NAME);
  return api.postHttpRequestAsync(`${baseUrl}${PRESCRIBE.GET_PDF}`, data);
};
